import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { AppShell } from '@/components/layout/AppShell';
import { ProtectedRoute } from './ProtectedRoute';
import { PageViewTracker } from '@/components/common/PageViewTracker';
import { LoginPage } from '@/pages/LoginPage';
import { SignUpPage } from '@/pages/SignUpPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { AuthCallbackPage } from '@/pages/AuthCallbackPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { GroupDetailPage } from '@/pages/GroupDetailPage';
import { AddExpensePage } from '@/pages/AddExpensePage';
import { ImportExpensesPage } from '@/pages/ImportExpensesPage';
import { ExpenseDetailPage } from '@/pages/ExpenseDetailPage';
import { EditExpensePage } from '@/pages/EditExpensePage';
import { SettleUpPage } from '@/pages/SettleUpPage';
import { JoinGroupPage } from '@/pages/JoinGroupPage';
import { NotificationsPage } from '@/pages/NotificationsPage';
import { ActivitiesPage } from '@/pages/ActivitiesPage';
import { StatisticsPage } from '@/pages/StatisticsPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { EditProfilePage } from '@/pages/EditProfilePage';
import { WalletPage } from '@/pages/WalletPage';
import { WalletTransactionsPage } from '@/pages/WalletTransactionsPage';
import { ExpensesPage } from '@/pages/ExpensesPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function AppRouter() {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />

        {/* Protected route without AppShell (recovery session) */}
        <Route path="/reset-password" element={<ProtectedRoute><ResetPasswordPage /></ProtectedRoute>} />

        {/* Protected routes with AppShell layout */}
        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/groups/:id" element={<GroupDetailPage />} />
          <Route path="/groups/:id/add" element={<AddExpensePage />} />
          <Route path="/groups/:id/import" element={<ImportExpensesPage />} />
          <Route path="/groups/:id/settle" element={<SettleUpPage />} />
          <Route path="/expenses" element={<ExpensesPage />} />
          <Route path="/expenses/:id" element={<ExpenseDetailPage />} />
          <Route path="/expenses/:id/edit" element={<EditExpensePage />} />
          <Route path="/join/:code" element={<JoinGroupPage />} />
          <Route path="/activities" element={<ActivitiesPage />} />
          <Route path="/statistics" element={<StatisticsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/edit" element={<EditProfilePage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/wallet/transactions" element={<WalletTransactionsPage />} />
        </Route>

        {/* Redirects */}
        <Route path="/groups" element={<Navigate to="/dashboard" replace />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}
